import { LocalStoreService } from "./LocalStoreService";

/**
 * Leva o usuário para o Analysis já autenticado.
 *
 * Mesmo trilho do `RedirectV2Service`: `/auth/live` recebe a contabilidade e o refresh token, o
 * app do outro lado troca por sessão e cai na rota pedida. Sem isso o cliente chegaria na tela de
 * login de um produto em que ele já está logado.
 *
 * Serviço separado, e não um parâmetro do `RedirectV2Service`, porque são apps diferentes com
 * URLs diferentes: um método que escolhe a base por bandeira esconderia para onde a pessoa vai.
 *
 * O `next` precisa estar liberado no `resolveAllowedNextPath` do Analysis — é a barreira de
 * open-redirect de lá. Rota que não estiver na lista cai no destino padrão, em silêncio.
 */
export class RedirectAnalysisService {
    LocalStoreService = new LocalStoreService();

    getUrl({ accountingId, next = null } = {}) {
        const baseUrl = publicSettings.urlAnalysis;
        if (!baseUrl || !accountingId) return null;

        const refreshToken = this.LocalStoreService.getItem(
            "nucont:refresh_token"
        );
        // Sem token o link sairia com `rwt=null` — texto, não ausência. O Analysis tentaria
        // trocar a string "null" por sessão, falharia e mostraria erro de autenticação para
        // quem só clicou num item do menu. Sem link é melhor do que link que acusa a pessoa.
        if (!refreshToken) return null;

        let url = `${baseUrl}/auth/live?accId=${accountingId}&rwt=${refreshToken}`;
        if (next) {
            url += `&next=${next}`;
        }
        return url;
    }

    redirect({ accountingId, next = null } = {}) {
        const url = this.getUrl({ accountingId, next });
        if (!url) return false;
        window.location.href = url;
        return true;
    }
}
